import React, { useContext } from 'react';
import { TabDispatchContext, TabStateContext } from '../providers/TabProvider';

export default function Tabs(props){
  const state = useContext(TabStateContext);
  const dispatch = useContext(TabDispatchContext);

  const handlerTabClick = (e) => {
    dispatch({ type: 'select', activeTab: e.currentTarget.id });
    if (typeof props.onTabClick === 'function') {
      props.onTabClick(e);
    }
  }

  const childrenWithExtraProp = React.Children.map(props.children, (child, index) => {
    const needSelectFirst = index == 0 && !state.activeTab;
    const idEquals = state.activeTab === child.props.id;

    return React.cloneElement(child, {
      onClick: handlerTabClick,
      active: needSelectFirst || idEquals
    });
  });

  return (
    <div className="chrome-tabs-content">
      {childrenWithExtraProp}
    </div>
  );
}
